import { config } from '../constants/config_constants';


const ACCOUNTS_LOGIN_URL = config.snapchat_accounts_login_url;
const REDIRECT_URI = encodeURIComponent(config.snapchat_redirect_uri);
class SnapchatAccountService {

    static getRedirectURL(client_id, scope, state, code_challenge) {
        return `${ACCOUNTS_LOGIN_URL}?response_type=code&client_id=${client_id}` +
            `&redirect_uri=${REDIRECT_URI}&state=${state}&code_challenge_method=S256` +
            `&code_challenge=${code_challenge}&scope=${scope}`;
    }
}


export default SnapchatAccountService;



// WEBPACK FOOTER //
// ./src/services/SnapchatAccountService.js